import type { ReactNode } from 'react';

import { ImpersonationSessionProvider } from '@highlight-cp/hooks';

import { useClientPortalAuth } from '../../auth/ClientPortalAuthProvider';
import { toLegacyImpersonationSessionState } from './to-legacy-impersonation-session-state';

export function ImpersonationSessionBridge({ children }: { children: ReactNode }) {
  const auth = useClientPortalAuth();
  const session = auth.status === 'authenticated' ? auth.session : null;

  return (
    <ImpersonationSessionProvider session={toLegacyImpersonationSessionState(session)}>
      {children}
    </ImpersonationSessionProvider>
  );
}
